import { ChevronRight } from "lucide-react";
import { TDS_REPORT_TYPES } from "../tdsReportsConfig";

export default function TdsReportTypeCards({ selectedId, onSelect, getStatus }) {
  return (
    <section className="tdsr-type-grid" aria-label="Report types">
      {TDS_REPORT_TYPES.map((report) => {
        const Icon = report.icon;
        const active = selectedId === report.id;
        const status = getStatus(report);
        return (
          <article
            key={report.id}
            className={`tdsr-type-card tdsr-type-card--${report.tone}${active ? " tdsr-type-card--active" : ""}`}
          >
            <div className="tdsr-type-card__top">
              <div className="tdsr-type-card__icon" aria-hidden="true">
                <Icon size={22} />
              </div>
              <span className={`tdsr-badge tdsr-badge--${status.tone}`}>{status.label}</span>
            </div>
            <h3 className="tdsr-type-card__title">{report.title}</h3>
            <p className="tdsr-type-card__desc">{report.description}</p>
            <button
              type="button"
              className="tdsr-type-card__btn"
              onClick={() => onSelect(report.id)}
            >
              {active ? "Selected" : "Open"}
              <ChevronRight size={14} />
            </button>
          </article>
        );
      })}
    </section>
  );
}
